import React from "react";
import { Link } from "react-router-dom";
import { newsItems } from "./posts";
import '../../styles/news/events.css';

export default function EventsPage() {
   return (
		<main className="postsPage">
			<div className="postsContainer">
				<section className="postsGrid" aria-label="Events">
					{newsItems.map((p) => (
						<article className="postCard" key={p.id}>
							<div className="postImageWrap">
								<img className="postImage" src={p.heroImageUrl} alt="" loading="lazy" />
							</div>

							<div className="postBody">
								<div className="postCategory">{p.category}</div>

								<h2 className="postTitle">
									<Link className="postTitleLink" to={`/events/${p.slug}`}>
										{p.title}
									</Link>
								</h2>

								{p.event && (
									<div className="postEventLine">
										<span className="postEventItem">📅 {p.event.dateLabel} • ⏰ {p.event.timeLabel} </span>
										<span className="postEventItem">📍 {p.event.locationLabel}</span>
									</div>
								)}

								<p className="postExcerpt">{p.excerpt}</p>

								<Link className="postReadMore" to={`/events/${p.slug}`}>
									READ MORE <span aria-hidden="true">→</span>
								</Link>
							</div>
						</article>
					))}
				</section>
			</div>
		</main>
  	);
}